const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://handbook.arhamlabs.com',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    logo: 'https://arhamlabs.com/assets/images/logo/logo-white.svg',
    logoLink: 'https://handbook.arhamlabs.com',
    title:
      "<a href='https://handbook.arhamlabs.com'><img class='img-responsive' src='https://arhamlabs.com/assets/images/logo/logo-white.svg' alt='Arham Labs logo' /></a>",
    githubUrl: 'https://github.com/arham-labs/arham-labs-knowledge-base',
    helpUrl: '',
    links: [{ text: '', link: '' }],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [
      // '/introduction', // add trailing slash if enabled above
      '/hr',
      '/general',
    ],
    collapsedNav: [
      '/general', // add trailing slash if enabled above
      '/hr', // add trailing slash if enabled above
      // '/design', // add trailing slash if enabled above
      // '/development', // add trailing slash if enabled above
    ],
    links: [{ text: 'Arham Labs', link: 'https://arhamlabs.com' }],
    frontline: false,
    ignoreIndex: true,
    title:
      "<a href='#'>Sandbox </a><div class='greenCircle'></div><a href='#'>GitHub</a>",
  },
  siteMetadata: {
    title: 'Arham Labs Knowledge Base',
    description: 'Documentation built with mdx.',
    ogImage: null,
    docsLocation: 'https://github.com/arham-labs/arham-labs-knowledge-base',
    favicon: 'https://arhamlabs.com/favicon/favicon-32x32.png',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'Arham Labs Handbook',
      short_name: 'ArhamLabsHandbook',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
